import { cn as packageCn, en as packageEn, jp as packageJp, tw as packageTw } from '@patsnap-biz/user-package-tags';

export const cn = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '查看全部 →',
        ...packageCn.UserPackageTags,
    },
}

export const en = {
    PtUserBanner: {
        endTime: 'Expiration Date: {date}',
        more: 'More →',
        ...packageEn.UserPackageTags,
    },
}

export const jp = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '続き →',
        ...packageJp.UserPackageTags,
    },
}

export const tw = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '檢視全部 →',
        ...packageTw.UserPackageTags,
    },
}
